export default {
  getTotals: (state) => state.dashboardData?.totals || { trips: 0, shipments: 0 },
  getDetails: (state) => state.dashboardData?.details || { trips: [], shipments: [] },
  getAssociatedPanels: (state) => state.associatedPanels || [],
  getAssociatedPanelsCounts: (state) => {
    const counts = {
      associated: 0,
      active: 0,
      suspended: 0,
      inactive: 0,
    };
    const panels = state.associatedPanels;
    panels.forEach((panel) => {
      const { status } = panel;
      counts[status] += 1;
      counts.associated += 1;
    });
    return counts;
  },
  getCreditDistribution: (state) => (
    state.creditDistribution || {
      master_credit_limit: 0,
      panels: [],
    }
  ),
};
